import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import route from './modules/route'
import search from './modules/search'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 全局状态
    count: 0
  },
  getters: {
    // 获取状态
    getCount: state => state.count
  },
  mutations: {
    // 同步修改状态
    INCREMENT(state) {
      state.count++
    },
    DECREMENT(state) {
      state.count--
    }
  },
  actions: {
    // 异步操作
    increment({ commit }) {
      commit('INCREMENT')
    },
    decrement({ commit }) {
      commit('DECREMENT')
    }
  },
  modules: {
    user,
    route,
    search
  }
})
